import { apiClient, getHeaders } from '@/services/axiosConfig'
export default {
  checkSerialNumber (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/warranty-activations/serial-number',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  checkModelName (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/warranty-activations/model',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  activateWarranty (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/general/warranty-activations',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  warrantyActivations (auth, payload) {
    return apiClient({
      method: 'get',
      url: '/v1/general/warranty-activations',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
